import { gql } from "@apollo/client"

export const ORDER_LIST_FRAG = gql`
  fragment OrderListFrag on OrderType {
    id
    isConsolidated
    orderStatus
    trackingCode
    outstandingAmount
    paymentMethod
    paymentStatus
    totalAmount
    createdAt
    metadata
    discount {
      id
      percentage
      flat
    }
    orderItems {
      id
      metadata
      discount {
        id
        percentage
        flat
      }
    }
    deliveryStatus
    orderCategory
    soNumber
    user {
      id
      fullName
      number
      shopsManaged {
        id
        name
      }
    }
    totalPaid
    shippingAddress {
      id
      address
      village
      district
    }
    user {
      id
      number
      fullName
    }
    pickupDate
    transactions {
      id
      referenceId
      amount
      createdAt
    }
  }
`

export const ORDER_DETAIL_FRAG = gql`
  fragment OrderDetailFrag on OrderType {
    id
    trackingCode
    outstandingAmount
    date
    soNumber
    isConsolidated
    deliveryStatus
    paymentStatus
    orderStatus
    paymentMethod
    shippingMethod
    pocName
    pocNumber
    totalAmount
    totalPaid
    crateCount
    billingDoc {
      id
      billingDocNumber
    }
    orderItems {
      id
      shipping {
        id
        estimatedDelivery
      }
    }
    user {
      id
      fullName
      number
      email
    }
    pocName
    pocNumber
    shippingAddress {
      id
      village
      address
    }
    transactions {
      id
      paymentMethod
      attachment {
        id
        url
      }
      referenceId
      amount
      status
    }
  }
`
export const PRINT_ORDER_INVOICE = gql`
  query OrderInvoiceDetail($orderId: ID!, $tripId: ID) {
    orderInvoiceDetail(orderId: $orderId, tripId: $tripId) {
      id
      invoiceDocumentPath
    }
  }
`
